export enum EBillingStatus {
  OK = 'ok',
  UNSTABLE = 'unstable',
}

export interface IBillingProblemReasons {
  deposit?: string | null;
  identification?: string | null;
}

export interface IBillingStatusState {
  /** Статус платежа */
  status: EBillingStatus;
  /** Поясняющие тексты */
  problemReasons?: IBillingProblemReasons;
}
